import { defineMessages, useIntl } from "react-intl";

import type { TravellerType } from "@/features/trips/types/types";

const labelMap = defineMessages({
  adultInDoubleRoom: {
    defaultMessage: "Adult in double room",
    description:
      "Traveller type option label: adult occupying a shared / double room",
  },
  adultInSingleRoom: {
    defaultMessage: "Adult in single room",
    description:
      "Traveller type option label: adult occupying a private single room",
  },
  childWithBed: {
    defaultMessage: "Child with bed",
    description: "Traveller type option label: child with a dedicated bed",
  },
  childWithoutBed: {
    defaultMessage: "Child without bed",
    description:
      "Traveller type option label: child sharing without a dedicated bed",
  },
  infant: {
    defaultMessage: "Infant",
    description: "Traveller type option label: infant",
  },
});

type Props = {
  rooms: Record<TravellerType, number>;
};

export function RoomList({ rooms }: Props) {
  const intl = useIntl();

  return (
    <ul className="space-y-1 text-sm font-medium text-text-primary">
      {Object.entries(rooms).map(([travellerType, count]) => {
        if (count === 0) return null;

        return (
          <li key={travellerType} className="text-sm">
            {count}x{" "}
            {intl.formatMessage(labelMap[travellerType as TravellerType])}
          </li>
        );
      })}
    </ul>
  );
}
